var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    !_vm.isMobileOrTablet
      ? _c(
          "table",
          {
            staticClass: "rb-rox-manual-prescription-table",
            class: {
              "rb-rox-manual-prescription-table--is-thank-you-page":
                _vm.isThankYouPage,
            },
          },
          [
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__header" },
              [
                _c("th", {
                  staticClass:
                    "rb-rox-manual-prescription-table__blank-content",
                }),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.sphere")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.cylinder")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.axis")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.add")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.prysm")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.pd")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__title",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation("prescription_module.table.od")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__subtitle",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation(
                                "prescription_module.table.right_eye"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rsphreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rcycreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.raxisreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.radddetails) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rhprysm) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "rb-rox-manual-prescription-table__column",
                    attrs: {
                      rowspan: _vm.isPupilaryDistanceASingleValue ? "4" : "2",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.isPupilaryDistanceASingleValue
                            ? _vm.tableValues.pupdistance
                            : _vm.tableValues.rpupdistance
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rvprysm) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__title",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation("prescription_module.table.os")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__subtitle",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation(
                                "prescription_module.table.left_eye"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "rb-rox-manual-prescription-table__column",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lsphreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "rb-rox-manual-prescription-table__column",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lcycreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "rb-rox-manual-prescription-table__column",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.laxisreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "rb-rox-manual-prescription-table__column",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.ladddetails) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-border-bottom--highlighted",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lhprysm) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.isPupilaryDistanceASingleValue
                  ? _c(
                      "td",
                      {
                        staticClass: "rb-rox-manual-prescription-table__column",
                        attrs: { rowspan: "2" },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.tableValues.lpupdistance) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lvprysm) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
          ]
        )
      : _c(
          "table",
          {
            staticClass: "rb-rox-manual-prescription-table",
            class: {
              "rb-rox-manual-prescription-table--is-thank-you-page":
                _vm.isThankYouPage,
            },
          },
          [
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__header" },
              [
                _c("th", {
                  staticClass:
                    "rb-rox-manual-prescription-table__blank-content",
                }),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__title",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation("prescription_module.table.od")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__subtitle",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation(
                                "prescription_module.table.right_eye"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "th",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__title",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation("prescription_module.table.os")
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "rb-rox-manual-prescription-table__column--first__subtitle",
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.translation(
                                "prescription_module.table.left_eye"
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.sphere")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rsphreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lsphreading) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.cylinder")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rcycreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lcycreading) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.axis")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.raxisreading) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.laxisreading) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.add")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.radddetails) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "rb-rox-manual-prescription-table__column" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.ladddetails) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              {
                staticClass:
                  "rb-rox-manual-prescription-table__content rb-rox-manual-prescription-table__content--base-height",
              },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first",
                    attrs: { rowspan: "2" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.prysm")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-rox-manual-prescription-table__column--base-height",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rhprysm) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-rox-manual-prescription-table__column--base-height",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lhprysm) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              {
                staticClass:
                  "rb-rox-manual-prescription-table__content rb-rox-manual-prescription-table__content--base-height",
              },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-rox-manual-prescription-table__column--base-height",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.rvprysm) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column rb-rox-manual-prescription-table__column--base-height",
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.lvprysm) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "tr",
              { staticClass: "rb-rox-manual-prescription-table__content" },
              [
                _c(
                  "td",
                  {
                    staticClass:
                      "rb-rox-manual-prescription-table__column--first border-bottom-style--hidden",
                    attrs: { rowspan: "4" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.translation("prescription_module.table.pd")
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "rb-rox-manual-prescription-table__column",
                    attrs: {
                      colspan: _vm.isPupilaryDistanceASingleValue ? "2" : "1",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.isPupilaryDistanceASingleValue
                            ? _vm.tableValues.pupdistance
                            : _vm.tableValues.rpupdistance
                        ) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                !_vm.isPupilaryDistanceASingleValue
                  ? _c(
                      "td",
                      {
                        staticClass: "rb-rox-manual-prescription-table__column",
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.tableValues.lpupdistance) +
                            "\n      "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
          ]
        ),
    _vm._v(" "),
    _vm.issueDateEnabled
      ? _c("div", { staticClass: "rb-rox-manual-prescription-details" }, [
          _c(
            "div",
            { staticClass: "rb-rox-manual-prescription-details__title" },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("rox_prescription.details")) +
                  "\n    "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "rb-rox-manual-prescription-details__description" },
            [
              _c("span", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("rox_prescription.date") + ":") +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "\n        " + _vm._s(_vm.formattedIssueDate) + "\n      "
                ),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.doctorNameEnabled
            ? _c(
                "div",
                {
                  staticClass:
                    "rb-rox-manual-prescription-details__description",
                },
                [
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("rox_prescription.doctor") + ":") +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.tableValues.doctorName) +
                        "\n      "
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }